module.exports = __webpack_public_path__ + "static/media/CreditSuisse-logo.650c517c.png";